import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Vue from 'vue';
import Vuex from 'vuex';
import indexPageModule from "./indexPageModule";
import subPageModule from "./subPageModule";
import getUserAgent from "../util/getUserAgent";
import { filterXSS } from '@/util/helper';

// client js begin
import env from '@tencent/vft-common/env';
import atom from '@tencent/vft-atom';
import { setSize } from '@/util/adaptation';
import login from '@tencent/vft-common/login';
import redServiceCoa from '@/services/redService';
import * as eggService from '@/services/eggService';
import { getSvipInfo } from '@/services/svipService';
// client js end
var config = {
  modules: {
    indexPageModule: indexPageModule,
    subPageModule: subPageModule
  },
  state: function state(ctx) {
    var userIp;
    if (ctx) {
      var xRealIp = ctx.get('X-Real-Ip');
      var ip = ctx.ip;
      var remoteAddress = ctx.req.connection.remoteAddress;
      userIp = ip || xRealIp || remoteAddress;
      console.log({
        ip: ip,
        remoteAddress: remoteAddress,
        xRealIp: xRealIp
      });
    }
    var ctxInfo = ctx ? {
      url: ctx.url,
      query: filterXSS(ctx.request.querystring || ''),
      cookie: ctx.req.headers['cookie'],
      userAgent: ctx.req.headers['user-agent'] || '',
      userIp: userIp
    } : null;
    return {
      ctxInfo: ctxInfo,
      isLogin: false,
      payVip: null,
      svip: null,
      userInfo: null,
      payVipUserInfoPromise: null,
      nowTimestamp: 0,
      isSubPage: false,
      isInApp: false,
      deviceSize: 'vft_regular',
      showRedPoint: false,
      getUserEggPromise: null,
      eggInfo: null
    };
  },
  mutations: {
    saveIsLogin: function saveIsLogin(state, isLogin) {
      state.isLogin = isLogin;
    },
    savePayVip: function savePayVip(state, payVip) {
      state.payVip = payVip;
    },
    saveSvip: function saveSvip(state, svip) {
      state.svip = svip;
    },
    saveUserInfo: function saveUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    saveIsSubPage: function saveIsSubPage(state, isSubPage) {
      state.isSubPage = isSubPage;
    },
    saveIsInApp: function saveIsInApp(state, isInApp) {
      state.isInApp = isInApp;
    },
    saveNowTimestamp: function saveNowTimestamp(state, nowTimestamp) {
      state.nowTimestamp = nowTimestamp;
    },
    saveDeviceSize: function saveDeviceSize(state, size) {
      state.deviceSize = size;
    },
    saveShowRedPoint: function saveShowRedPoint(state, isShowRedPoint) {
      state.showRedPoint = isShowRedPoint;
    },
    saveEggInfo: function saveEggInfo(state, eggInfo) {
      state.eggInfo = eggInfo;
    }
  },
  actions: {
    getShowRedPoint: function () {
      var _getShowRedPoint = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
        var commit, state, data, isShowRedPoint;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit, state = _ref.state;
                _context.next = 3;
                return redServiceCoa();
              case 3:
                data = _context.sent;
                isShowRedPoint = data.red_list.length ? data.red_list[0].show_flag : 0;
                commit('saveShowRedPoint', isShowRedPoint);
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function getShowRedPoint(_x) {
        return _getShowRedPoint.apply(this, arguments);
      }
      return getShowRedPoint;
    }(),
    getEggInfo: function () {
      var _getEggInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, info) {
        var commit, state, eggInfo;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref2.commit, state = _ref2.state;
                if (state.indexPageModule.serverSetting && state.indexPageModule.serverSetting['福利社摇蛋'] && state.indexPageModule.serverSetting['福利社摇蛋'].活动Id) {
                  eggService.setActId(state.indexPageModule.serverSetting['福利社摇蛋'].活动Id);
                }
                _context2.next = 4;
                return eggService.getEggInfo();
              case 4:
                eggInfo = _context2.sent;
                commit('saveEggInfo', eggInfo);
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function getEggInfo(_x2, _x3) {
        return _getEggInfo.apply(this, arguments);
      }
      return getEggInfo;
    }(),
    getEggPromise: function () {
      var _getEggPromise = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref3) {
        var dispatch, state;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = _ref3.dispatch, state = _ref3.state;
                if (eggService.getActId()) {
                  _context4.next = 6;
                  break;
                }
                if (state.indexPageModule.serverSetting && state.indexPageModule.serverSetting['福利社摇蛋'] && state.indexPageModule.serverSetting['福利社摇蛋'].活动Id) {
                  eggService.setActId(state.indexPageModule.serverSetting['福利社摇蛋'].活动Id);
                }
                if (eggService.getActId()) {
                  _context4.next = 6;
                  break;
                }
                state.getUserEggPromise = null;
                return _context4.abrupt("return");
              case 6:
                state.getUserEggPromise = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          _context3.next = 3;
                          return dispatch('getEggInfo');
                        case 3:
                          _context3.next = 8;
                          break;
                        case 5:
                          _context3.prev = 5;
                          _context3.t0 = _context3["catch"](0);
                          console.log('获取用户的egg信息报错：', _context3.t0);
                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[0, 5]]);
                }))();
                return _context4.abrupt("return", state.getUserEggPromise);
              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      function getEggPromise(_x4) {
        return _getEggPromise.apply(this, arguments);
      }
      return getEggPromise;
    }(),
    checkLogin: function () {
      var _checkLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5) {
        var commit, state, isLogin;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit = _ref5.commit, state = _ref5.state;
                _context5.next = 3;
                return new Promise(function (resolve, reject) {
                  login.init(resolve);
                });
              case 3:
                isLogin = login.isLogin();
                commit('saveIsLogin', isLogin);
                return _context5.abrupt("return", isLogin);
              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      function checkLogin(_x5) {
        return _checkLogin.apply(this, arguments);
      }
      return checkLogin;
    }(),
    getUserInfo: function () {
      var _getUserInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref6) {
        var commit, state, userInfo, oldVal, newVal;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit = _ref6.commit, state = _ref6.state;
                _context6.next = 3;
                return login.getMainUserInfo();
              case 3:
                userInfo = _context6.sent;
                oldVal = state.userInfo;
                newVal = userInfo;
                if (userInfo) {
                  if (!oldVal) {
                    commit('saveUserInfo', userInfo);
                  } else if (oldVal.type !== newVal.type || oldVal.id !== newVal.id) {
                    commit('saveUserInfo', userInfo);
                  }
                }
              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      function getUserInfo(_x6) {
        return _getUserInfo.apply(this, arguments);
      }
      return getUserInfo;
    }(),
    getPayVip: function () {
      var _getPayVip = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7) {
        var commit, payVip, svipInfo;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commit = _ref7.commit;
                _context7.next = 3;
                return atom.getPayVip();
              case 3:
                payVip = _context7.sent;
                commit('savePayVip', payVip);
                _context7.prev = 5;
                _context7.next = 8;
                return getSvipInfo();
              case 8:
                svipInfo = _context7.sent;
                commit('saveSvip', svipInfo);
                _context7.next = 15;
                break;
              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](5);
                console.log('获取svip信息失败：', _context7.t0);
              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[5, 12]]);
      }));
      function getPayVip(_x7) {
        return _getPayVip.apply(this, arguments);
      }
      return getPayVip;
    }(),
    getPayVipAndUserInfo: function getPayVipAndUserInfo(_ref8) {
      var state = _ref8.state,
        dispatch = _ref8.dispatch;
      state.payVipUserInfoPromise = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return dispatch('checkLogin');
              case 3:
                if (!state.isLogin) {
                  _context8.next = 9;
                  break;
                }
                // 碰蛋下线，不默认请求碰蛋信息
                // dispatch('getEggPromise')
                dispatch('getShowRedPoint');
                _context8.next = 7;
                return Promise.all([dispatch('getPayVip'), dispatch('getUserInfo')]);
              case 7:
                _context8.next = 12;
                break;
              case 9:
                if (!env.isIos) {
                  _context8.next = 12;
                  break;
                }
                _context8.next = 12;
                return Promise.all([dispatch('getPayVip')]);
              case 12:
                _context8.next = 17;
                break;
              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](0);
                console.error(_context8.t0);
              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 14]]);
      }))();
      return state.payVipUserInfoPromise;
    },
    startTimer: function startTimer(_ref10, nowTimestamp) {
      var state = _ref10.state;
      // if (state.nowTimestamp) return

      var _now = parseInt(Date.now() / 1000);

      // 避免由于浏览器端的缓存，时间需要特别处理
      // const serverTimeKey = 'welfare-server-time'
      // const localTimeKey = 'welfare-local-time'
      // let serverTime = sessionStorage.getItem(serverTimeKey)
      //
      // if (serverTime && parseInt(serverTime) === nowTimestamp) {
      //   _now = parseInt(sessionStorage.getItem(localTimeKey))
      // } else {
      //   sessionStorage.setItem(serverTimeKey, nowTimestamp + '')
      //   sessionStorage.setItem(localTimeKey, _now + '')
      // }

      var calculate = function calculate() {
        state.nowTimestamp = nowTimestamp + (parseInt(Date.now() / 1000) - _now);
      };
      calculate();
      setInterval(calculate, 1000);
    },
    checkIsApp: function checkIsApp(_ref11) {
      var commit = _ref11.commit,
        state = _ref11.state;
      var userAgent = getUserAgent(state.ctxInfo) || '';
      commit('saveIsInApp', userAgent.indexOf('QQLive') >= 0);
    },
    setDeviceSize: function setDeviceSize(_ref12) {
      var commit = _ref12.commit;
      var size = setSize();
      commit('saveDeviceSize', size || 'vft_regular');
    }
  }
};
Vue.use(Vuex);
export function createStore(ctx) {
  var modules = config.modules,
    state = config.state,
    actions = config.actions,
    mutations = config.mutations;
  return new Vuex.Store({
    modules: modules,
    mutations: mutations,
    state: state(ctx),
    actions: actions
  });
}